import ToggleButtonV2 from './ToggleButtonV2';

export default ToggleButtonV2;
